var React = require('react');

function StatusCrashedOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 32C7.16 32 0 24.84 0 16S7.16 0 16 0s16 7.16 16 16-7.16 16-16 16zm0-2c7.73 0 14-6.27 14-14S23.73 2 16 2 2 8.27 2 16s6.27 14 14 14zm4.02-26l-3.05 10H23L11.92 28l4.05-10H10L20.02 4z","fillRule":"evenodd"}));
}

StatusCrashedOutline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = StatusCrashedOutline;

StatusCrashedOutline.default = StatusCrashedOutline;
